export const handleChangeInputsEditProfilePage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_EDIT_PROFILE', name, value
});